import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms'
@Component({
  selector: 'app-add-maslol',
  templateUrl: './add-maslol.component.html',
  styleUrls: ['./add-maslol.component.scss']
})
export class AddMaslolComponent implements OnInit {

  @Input() qID: number = null;
  @Input() public titles: string[];
  @Input() public index: number;
  @Input() public maslol: FormGroup;
  @Output() public removed: EventEmitter<number> = new EventEmitter<number>();
  @Input() public displayErrors: boolean;
  @Input() public ph: string[];
  @Input() public displayX: boolean;


  defaultValue = "";

  
  
  constructor() { }

  ngOnInit() {
	
  }

  static buildMaslol(val: any) {
    return new FormGroup({
      internalMaslol: new FormControl(val[0]? val[0].answerValue : "")
	});
}
  
}



// WEBPACK FOOTER //
// ./src/app/add-maslol/add-maslol.component.ts